export default async function getNumberKamilReads() {
  const response = await fetch('https://api.idrissa-sall.com/kamil/mini/juzu');
  const data = await response.json();

  return data.numberOfReads;
}